/**
 * project_management#188: the analysis labels the R-peaks it detected, so a
 * peak an annotator deletes keeps its ML label ("U", "S", …). Drawn as is, the
 * orange label stays on the chart with no R under it (e.g. false R-peaks on
 * tall T-waves). Keep only the labels whose beat is still in the chart's R-peak
 * list.
 *
 * The match is exact: both lists carry the analysis' own peak indexes, and a
 * false peak can sit 61 samples from a real one, so any tolerance would hide
 * the real beat's label too. The backend applies the same rule on load; this
 * covers deletions made during the session.
 */
export const withoutDeletedBeats = <T extends { sampleIndex: number }>(
  labels: T[],
  beats: { sampleIndex: number }[] | undefined,
): T[] => {
  if (!beats) return labels;
  const beatSamples = new Set(beats.map(({ sampleIndex }) => sampleIndex));

  return labels.filter(({ sampleIndex }) => beatSamples.has(sampleIndex));
};
